//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { XTAlbum } from "@/models";
import AlbumItem from "@/components/xc_time/AlbumItem.vue";
import AlbumTags from "@/components/xc_time/AlbumTags.vue";
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      recommendAlbums: null,
      albumTags: null,
      page: 1, // tag page
      perPage: 15, // tag Perpage
      loading: false
    };
  },

  metaInfo() {
    return {
      title: "中国传统文化音频平台",
      // titleTemplate: null,
      meta: [{ name: "description", content: "中国传统文化音频平台" }]
    };
  },

  created() {
    XTAlbum.getPublicRecommendXTAlbums(1, 3).then(result => {
      this.recommendAlbums = result;
    });

    this.getXTAlbumTags();
  },

  scrollBottom() {
    this.getXTAlbumTags();
  },

  methods: {
    ...mapMutations(["setCurrentAlbum"]),

    getXTAlbumTags() {
      if (this.loading) {
        return;
      }

      this.loading = true;

      XTAlbum.getXTAlbumTagsWithAlbums(this.page, this.perPage).then(result => {
        if (result.length > 0) {
          this.albumTags = Array.isArray(this.albumTags)
            ? this.albumTags.concat(result)
            : result;
          this.loading = false;
          this.page = this.page + 1;
        } else {
          console.log("tag 加载完成");
        }
      });
    },

    goToXCTAlbum(album) {
      this.setCurrentAlbum(album);
      this.$router.push({
        name: "xctAlbum",
        params: {
          albumId: album.id
        }
      });
    },

    goToAlbumList(albumTag) {
      let tagId;
      let tagName;

      if (typeof albumTag === "string") {
        tagId = albumTag;
        tagName = "推荐";
      } else {
        tagId = albumTag.tag.id;
        tagName = albumTag.tag.get("name");
      }

      this.$router.push({
        name: "xctAlbums",
        params: {
          tagId: tagId,
          tagName: tagName
        }
      });
    }
  },

  components: {
    AlbumItem,
    AlbumTags
  }
};



// WEBPACK FOOTER //
// ./src/pages/XCTime.vue